import { Box, Stack, Typography } from "@mui/material";
import * as React from "react";
import { SyndeticsTermsLink } from "./syndetics/SyndeticsTermsLink";
import { useLanguage } from "../../Language";
import { useLocationConfiguration } from "../../LocationConfiguration";
import { useOutletContext } from "react-router-dom";
import { LocalCopies } from "../resource/LocalCopies";
import { StackMapProvider } from "../../Stackmap";
import { SyndeticsSummary } from "./syndetics/SyndeticsSummary";
import axios from "axios";
import { ReadingLevelSummary } from "./ReadingLevelSummary";
import { TagDisplay } from "./TagDisplay";
import { DetailsValueLink, DetailsValueLinkType } from "./SearchLink";
import { ResourceDWR } from "@tlc/ls2pac/dto/ResourceDWR";

export interface DetailsValue {
  value: string;
  linkValue: string;
  linkType: DetailsValueLinkType; // string on the backend
}
interface DetailsSection {
  label: string;
  tagLocation: boolean;
  detailsValues: DetailsValue[];
}

export const DetailsPage: React.FC = () => {
  const resource = useOutletContext<ResourceDWR>();
  const { translate } = useLanguage();
  const { locationConfiguration } = useLocationConfiguration();
  const { displayCopiesFirst } =
    locationConfiguration?.pacSettings?.displaySettings || {};
  const { allowTagging } =
    locationConfiguration?.pacSettings?.userActionSettings || {};

  const [detailsSections, setDetailsSections] = React.useState<
    DetailsSection[]
  >([]);

  React.useEffect(() => {
    const getDetails = async (resourceId: number) => {
      // TODO caching
      const { data } = await axios.get<DetailsSection[]>(
        `resource/details/${resourceId}`
      );
      setDetailsSections(data);
    };
    if (resource?.id) {
      getDetails(resource.id);
    }
  }, [resource?.id]);

  // TODO RSS feed and ContentDM version

  return (
    <StackMapProvider>
      <Stack direction={"column"} sx={{ flexGrow: 1 }}>
        <Box sx={{ flexGrow: 1 }}>
          <SyndeticsSummary resource={resource} />

          {displayCopiesFirst && <LocalCopies resource={resource} />}
          <ReadingLevelSummary resource={resource}></ReadingLevelSummary>
          {detailsSections.map(
            ({ label, tagLocation, detailsValues }, index) => (
              <Box key={`ds_${index}`}>
                {detailsValues?.length > 0 && (
                  <>
                    <Typography variant="h6" component={"h4"}>
                      {translate(label)}
                    </Typography>
                    <ul style={{ listStyle: "none", margin: "0 0 16px 0" }}>
                      {detailsValues.map(
                        ({ linkType, linkValue, value }, i) => (
                          <li key={`ds_${index}_dv_${i}`}>
                            {linkType && (
                              <DetailsValueLink
                                value={value}
                                linkType={linkType}
                                linkValue={linkValue}
                              />
                            )}
                            {!linkType && <>{value}</>}
                          </li>
                        )
                      )}
                    </ul>
                  </>
                )}
                {tagLocation && <TagDisplay resource={resource}></TagDisplay>}
              </Box>
            )
          )}
          {!displayCopiesFirst && <LocalCopies resource={resource} />}
        </Box>
        <Box>
          <SyndeticsTermsLink />
        </Box>
      </Stack>
    </StackMapProvider>
  );
};
